import {Button, ButtonSize, ButtonStyle} from '@mintdata-wsp/common/components/button/Button';
import {StepCircle, StepCircleSize, StepCircleState} from '@mintdata-wsp/common/components/stepCircle/StepCircle';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {ConnectDomainState} from '@mintdata-wsp/common/state/ui/publish/PublishState';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ConnectDomainFirstStep} from '@mintdata-wsp/wsp/ui/dialogs/publish/ConnectDomainFirstStep';
import {ConnectDomainSecondStep} from '@mintdata-wsp/wsp/ui/dialogs/publish/ConnectDomainSecondStep';
import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import {GUID} from '@mintdata/mint-kit/api/models/GUID';
import {Popover} from '@mintdata/mint-kit/impl/components/popover/Popover';
import {PopupAnchor, PopupSize, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('@mintdata-wsp/wsp/ui/dialogs/publish/ConnectDomainDialog.less');
const cx = classnames.bind(styles);

export interface IConnectDomainDialogProps
{
}

@observer
export class ConnectDomainDialog extends BaseComponentWithContext<IConnectDomainDialogProps>
{
    private _id:GUID = IdUtil.newGUID();

    @bind
    private _onCancelClicked():void
    {
        controllers.ui.publish.hideConnectDomainDialog();
    }

    @bind
    private _onContinueClicked():void
    {
        controllers.ui.publish.nextConnectDomainDialogStep();
    }

    public render():JSX.Element
    {
        const {popupManager} = this.context;
        const {
            isConnectDomainMode,
            connectDomainState,
            cnameHostname
        } = rootState.ui.publish;
        const isFirstStep:boolean = connectDomainState === ConnectDomainState.Default;

        return <div
            ref={popupManager.position(
                this._id,
                SourceAnchor.CenterBottom,
                PopupAnchor.CenterTop,
                PopupSize.Original
            )}
        >
            {isConnectDomainMode && <Popover
                id={this._id}
                isModal={true}
                className={styles.connectDomain}
                onDismissed={this._onCancelClicked}
            >
                <Column>
                    <div className={styles.title}>Connect domain</div>
                    <div className={styles.separator} />
                    <Column className={styles.contentColumn}>
                        <Row className={styles.stepsRow}>
                            <StepCircle
                                text="1"
                                size={StepCircleSize.Medium}
                                state={isFirstStep ? StepCircleState.Active : StepCircleState.Passed}
                            />
                            <div className={styles.stepLabel}>Add domain</div>
                            <div className={styles.stepSeparator} />
                            <StepCircle
                                text="2"
                                size={StepCircleSize.Medium}
                                state={isFirstStep ? StepCircleState.Default : StepCircleState.Active}
                            />
                            <div className={styles.stepLabel}>Go live</div>
                        </Row>
                        {isFirstStep ? <ConnectDomainFirstStep /> : <ConnectDomainSecondStep />}
                    </Column>
                    <Row className={cx('actionRow')}>
                        <Button
                            caption="Cancel"
                            className={styles.cancelButton}
                            onClick={this._onCancelClicked}
                            style={ButtonStyle.SimpleSecondary}
                            size={ButtonSize.Large}
                        />
                        <Button
                            caption={connectDomainState === ConnectDomainState.Default ? 'Continue' : 'Finish'}
                            className={styles.continueButton}
                            onClick={this._onContinueClicked}
                            style={ButtonStyle.Raised}
                            size={ButtonSize.Large}
                            isDisabled={!cnameHostname || connectDomainState === ConnectDomainState.Checking}
                        />
                    </Row>
                </Column>
            </Popover>}
        </div>;
    }
}
